import { Modal, ModalProps } from './Modal'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Title3, BodyLarge } from '../styles/Typography'
import { Success } from '../icons'

interface SuccessModalProps extends ModalProps {
  title: string
  text?: string
}

export const SuccessModal = ({ title, text, onClose }: SuccessModalProps) => {
  return (
    <Modal onClose={onClose}>
      <Container>
        <Success color={theme.color.green} size={60} />
        <Title3>{title}</Title3>
        {text && <StyledBodyLarge>{text}</StyledBodyLarge>}
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
  justify-content: center;
  min-width: 300px;
  text-align: center;

  h3 {
    margin-top: ${theme.spacing.medium}px;
  }
`
const StyledBodyLarge = styled(BodyLarge)`
  margin-bottom: ${theme.spacing.large}px;
`
